import { lazy, Suspense, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Lenis from "lenis";
import Home from "@/pages/Home";
const Admin = lazy(() => import("@/pages/Admin"));
const Display = lazy(() => import("@/pages/Display"));
const CoinDetail = lazy(() => import("@/pages/CoinDetail"));

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App" dir="rtl">
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-[#0a0a0c]" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/tv" element={<Display />} />
            <Route path="/coin/:id" element={<CoinDetail />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-center" richColors theme="dark" dir="rtl" />
    </div>
  );
}

export default App;
